import { styled } from '@mui/material/styles';

export const CPWrapper = styled('div')`
  flex-grow: 1;
  padding-right: 40px;
  overflow-x: hidden;
  max-width: 100%;
  padding-left: 40px;
`;
